// 组件对象，大写
import cascaderRemote from './cascaderRemote.vue'
export default cascaderRemote
